import Modal from '../../modal/Modal';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { Category } from '../../api/category';
import s3Object from '../../service/s3getObject';
import { CategoryImageTitle } from './CategoryImageTitle';
import { AlertBanner } from '../../components/AlertBanner';
import { Option } from '../../types/option';

type Props = {
    isOpen: boolean;
    category: Category;
    handleClose: () => void;
    handleConfirm: () => void;
    apiError: Option<string>;
};

export function CategoryArchiveModal({
    isOpen,
    category,
    handleClose,
    handleConfirm,
    apiError,
}: Props) {
    return (
        <Modal isOpen={isOpen} onClose={handleClose} className="w-full min-h-48">
            <div className="flex flex-col items-center w-full gap-3">
                <ModalHeader>Archiver la catégorie</ModalHeader>
                <div className={'mt-5'}>
                    <CategoryImageTitle
                        title={category.title}
                        image={category.media.map(media => s3Object(media.url)).getOrElse('')}
                    />
                </div>
                {apiError
                    .map(message => <AlertBanner key="archive-error">{message}</AlertBanner>)
                    .toNull()}
                <ModalFooter
                    handlePrimaryAction={handleConfirm}
                    handleSecondaryAction={handleClose}
                    primaryActionTitle={'Archiver'}
                />
            </div>
        </Modal>
    );
}
